import React from 'react';
import { View, Text, Image, StyleSheet, ViewStyle, ImageStyle } from 'react-native';

export interface CoverImageProps {
  uri?: string;
  containerStyle?: ViewStyle;
  imageStyle?: ImageStyle;
  placeholderText?: string;
  children?: React.ReactNode; // overlay actions
}

const CoverImage: React.FC<CoverImageProps> = ({ uri, containerStyle, imageStyle, placeholderText = '上传封面图片（占位）', children }) => {
  return (
    <View style={[styles.coverWrap, containerStyle]}> 
      {uri ? (
        <Image source={{ uri }} style={[styles.coverImage, imageStyle]} />
      ) : (
        <View style={styles.coverPlaceholder}><Text style={{ color: '#9CA3AF' }}>{placeholderText}</Text></View>
      )}
      {children ? (
        <View style={styles.overlay}>{children}</View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  coverWrap: { height: 220, backgroundColor: '#F3F4F6', overflow: 'hidden', alignItems: 'center', justifyContent: 'center', position: 'relative' },
  coverImage: { width: '100%', height: '100%' },
  coverPlaceholder: { width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' },
  overlay: { position: 'absolute', right: 12, bottom: 12, flexDirection: 'row', gap: 8, zIndex: 2 },
});

export default CoverImage;
